module.exports = __webpack_public_path__ + "media/images/components/map-icons/contacts-map-pin-campaign_team-2ba252c159c3c1fd2fb7bc9237941f05.png";